export default {
  GET_PLACE_OF_WORK: state => state.placeOfWork,
}
